import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { isEmpty } from 'lodash';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useAllProductClearanceStock from '../useAllProductClearanceStock';
const usePDPOptionsClearanceData = (t0, t1, t2) => {
  const $ = _c(15);
  const id = t0 === undefined ? null : t0;
  const slug = t1 === undefined ? null : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const hookOptions = t3;
  const {
    delayLoad: t4,
    skip: t5,
    defaultValue: t6
  } = hookOptions;
  const delayLoad = t4 === undefined ? false : t4;
  const skip = t5 === undefined ? false : t5;
  let t7;
  if ($[2] !== t6) {
    t7 = t6 === undefined ? {} : t6;
    $[2] = t6;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const defaultValue = t7;
  const {
    loading: clearanceLoading,
    data: clearanceData
  } = useAllProductClearanceStock();
  let t8;
  if ($[4] !== delayLoad) {
    t8 = {
      skipPDPStateHook: false,
      delayLoad
    };
    $[4] = delayLoad;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const {
    loading: basicLoading,
    error: basicError,
    data: basicData
  } = usePDPBasicDetails(id, slug, t8);
  let t9;
  if ($[6] !== basicData || $[7] !== clearanceData) {
    t9 = !isEmpty(clearanceData) && basicData?.id ? clearanceData[basicData.id] : {};
    $[6] = basicData;
    $[7] = clearanceData;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const optionsClearanceData = t9;
  const dataLoading = clearanceLoading || basicLoading;
  const errorFound = basicError;
  if (skip) {
    return defaultValue;
  }
  let t10;
  if ($[9] !== optionsClearanceData) {
    t10 = {
      optionsClearanceData
    };
    $[9] = optionsClearanceData;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== dataLoading || $[12] !== errorFound || $[13] !== t10) {
    t11 = {
      loading: dataLoading,
      error: errorFound,
      data: t10
    };
    $[11] = dataLoading;
    $[12] = errorFound;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  return t11;
};
export default usePDPOptionsClearanceData;